import { jsx as _jsx } from "react/jsx-runtime";
import { InnerToken } from "./inner.js";
import { isGroup } from "./tokens.js";
export function renderLineContent({ content, handlers, annotationStack, }) {
    return content.map((item, i) => isGroup(item) ? (_jsx(InlinedTokens, { annotationStack: annotationStack, handlers: handlers, group: item }, i)) : item.style ? (_jsx(FinalToken, { annotationStack: annotationStack, handlers: handlers, token: item }, i)) : (
    // whitespace
    item.value));
}
function FinalToken({ handlers, token, annotationStack, }) {
    const stack = buildTokenStack(handlers, annotationStack);
    return (_jsx(InnerToken, { merge: { _stack: stack, style: token.style, value: token.value } }));
}
function InlinedTokens({ group, handlers, annotationStack, }) {
    var _a;
    const { annotation, content } = group;
    const { name } = annotation;
    const children = renderLineContent({
        content,
        handlers,
        annotationStack: [...annotationStack, annotation],
    });
    const Component = (_a = handlers.find((c) => c.name === name)) === null || _a === void 0 ? void 0 : _a.Inline;
    return Component ? (_jsx(Component, { annotation: annotation, children: children })) : (children);
}
function buildTokenStack(handlers, annotationStack) {
    const stack = [];
    handlers.forEach(({ name, Token, AnnotatedToken }) => {
        const annotations = annotationStack.filter((a) => a.name === name);
        if (AnnotatedToken) {
            annotations.forEach((annotation) => stack.push({ Component: AnnotatedToken, annotation }));
        }
        if (Token) {
            if (!annotations.length) {
                stack.push({ Component: Token });
            }
            annotations.forEach((annotation) => stack.push({ Component: Token, annotation }));
        }
    });
    return stack;
}
